/// <amd-dependency path='VSS/LoaderPlugins/Css!TestManagement' />

import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import { AssignTestersToSuite } from "TestManagement/Scripts/TFS.TestManagement.AssignTestersToSuite";

export interface IAssignTestersToSuiteProps {
    planId: number;
    suite: any;
    dialogClosedCallBack: (changesSaved?: boolean) => void;
    showErrorCallBack: (string) => void;
}

// This is a proxy component to assign testers to run all test cases in a suite in the new web platform using LegacyComponent
class AssignTestersToSuiteProxy extends React.Component<IAssignTestersToSuiteProps, {}> {
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        let assignTestersToSuite: AssignTestersToSuite = new AssignTestersToSuite();
        assignTestersToSuite.AssignTesters(this.props.planId, this.props.suite, this.props.dialogClosedCallBack, this.props.showErrorCallBack);
    }
}

registerLWPComponent("assign-testers-dialog-proxy", AssignTestersToSuiteProxy);
